import React, { FC, PropsWithChildren } from 'react';
import { IconButton } from '@material-ui/core';
import { SnackbarKey, SnackbarProvider as BaseSnackbarProvider, useSnackbar } from 'notistack';
import CloseIcon from '@material-ui/icons/Close';
import { makeStyles } from '@material-ui/core/styles';

const CloseButton: FC<{ snackKey: SnackbarKey }> = ({ snackKey }) => {
    const { closeSnackbar } = useSnackbar();
    return (
        <IconButton
            aria-label="Close notification"
            color="inherit"
            onClick={() => closeSnackbar(snackKey)}
        >
            <CloseIcon fontSize="small" />
        </IconButton>
    );
};

const useStyles = makeStyles(() => ({
    root: {
        maxWidth: '40vw',
        wordWrap: 'break-word',
        wordBreak: 'break-all',
    },
}));

const SnackbarProvider = ({ children }: PropsWithChildren<any>) => {
    const styles = useStyles();
    return (
        <BaseSnackbarProvider
            maxSnack={5}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            autoHideDuration={5000}
            classes={{ root: styles.root }}
            action={(key: SnackbarKey) => <CloseButton snackKey={key} />}
        >
            {children}
        </BaseSnackbarProvider>
    );
};

export default SnackbarProvider;
